export const blog_categories_data = [
  {
    key: '1',
    category: 'Evlovution',
    created_date: '12/09/2024',
    status: 'Active',
  },
  {
    key: '2',
    category: 'Security',
    created_date: '18/02/2024',
    status: 'Active',
  },
  {
    key: '3',
    category: 'Guide',
    created_date: '24/10/2024',
    status: 'Active',
  },
  {
    key: '4',
    category: 'Recruitment',
    created_date: '17/10/2024',
    status: 'Active',
  },
  {
    key: '5',
    category: 'Payroll',
    created_date: '20/07/2024',
    status: 'Active',
  },
  {
    key: '6',
    category: 'Benefits',
    created_date: '10/04/2024',
    status: 'Active',
  },
  {
    key: '7',
    category: 'Employee',
    created_date: '22/02/2024',
    status: 'Active',
  },
  {
    key: '8',
    category: 'Onboarding',
    created_date: '03/11/2024',
    status: 'Active',
  },
  {
    key: '9',
    category: 'Implementation',
    created_date: '17/12/2024',
    status: 'Active',
  },
  {
    key: '10',
    category: 'Management',
    created_date: '24/10/2024',
    status: 'Active',
  },
  ];